import { Serializer } from "jsonapi-serializer";
import { AdminProfileInfo } from "../../api/typings/Profiles";
import { IApiResourceResponse } from "../../@typings/client";

export async function getUpdateProfileData(data: AdminProfileInfo): Promise<IApiResourceResponse<AdminProfileInfo>> {
  return new Serializer("users_profiles_admins", {
    keyForAttribute: "snake_case",
    attributes: ["is_super"],
  }).serialize(data);
}
